import { render, staticRenderFns } from "./Status.vue?vue&type=template&id=47457390&scoped=true&"
import script from "./Status.vue?vue&type=script&lang=ts&"
export * from "./Status.vue?vue&type=script&lang=ts&"
import style0 from "./Status.vue?vue&type=style&index=0&id=47457390&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47457390",
  null
  
)

export default component.exports